export enum ExamDayStatus {
    CommingSoon = 1,
    InProgress = 2,
    WaitingFinish = 3,
    Realized = 4
}
